const headers: Record<string, string[]> = {
  Claims: [
    'Claim_ID',
    'Policy_Holder',
    'Claim_Date',
    'Claim_Amount',
    'Claim_Status',
    'Policy_Number',
    'Incident_Date',
    'Incident_Type',
    'Claim_Processed_By',
    'Payout_Date',
    'SSN',
  ],
  Policy_Holders: [
    'Policy_Holder_ID',
    'Policy_Holder',
    'Policy_Number',
    'Policy_Type',
    'Policy_Start_Date',
    'Policy_End_Date',
    'SSN',
  ],
  Orders: ['id', 'userId', 'items', 'totalPrice', 'orderDate', 'partitionKey'],
};

const data: Record<string, string[][]> = {
  Claims: [
    [
      '1008',
      'Alice Johnson',
      '2024-01-01',
      '12363',
      'Pending',
      '1131',
      '2023-12-01',
      'Theft',
      'Jane Smith',
      '',
      '***-**-****',
    ],
    [
      '1023',
      'Bob Smith',
      '2024-01-16',
      '14339',
      'Pending',
      '1115',
      '2023-12-11',
      'Theft',
      'Michael Brown',
      '',
      '***-**-****',
    ],
    [
      '1013',
      'Charlie Brown',
      '2024-01-31',
      '5826',
      'Denied',
      '1122',
      '2023-12-21',
      'Fire',
      'Sarah Johnson',
      '',
      '***-**-****',
    ],
    [
      '1018',
      'David Wilson',
      '2024-02-15',
      '5177',
      'Pending',
      '1125',
      '2023-12-31',
      'Theft',
      'Sarah Johnson',
      '2024-01-14',
      '***-**-****',
    ],
    [
      '1021',
      'Eva Green',
      '2024-03-01',
      '1881',
      'Denied',
      '1119',
      '2024-01-10',
      'Vandalism',
      'Emily Davis',
      '',
      '***-**-****',
    ],
    [
      '1010',
      'Frank Harris',
      '2024-03-16',
      '4819',
      'Pending',
      '1116',
      '2024-01-20',
      'Car Accident',
      'John Doe',
      '2024-02-24',
      '***-**-****',
    ],
    [
      '1001',
      'Grace Lee',
      '2024-03-31',
      '1544',
      'Denied',
      '1121',
      '2024-01-30',
      'Theft',
      'John Doe',
      '',
      '***-**-****',
    ],
    [
      '1012',
      'Hannah King',
      '2024-04-15',
      '2633',
      'Denied',
      '1118',
      '2024-02-09',
      'Theft',
      'Sarah Johnson',
      '',
      '***-**-****',
    ],
    [
      '1003',
      'Isaac Clarke',
      '2024-04-30',
      '14072',
      'Pending',
      '1129',
      '2024-02-19',
      'Car Accident',
      'Jane Smith',
      '',
      '***-**-****',
    ],
    [
      '1009',
      'Jackie Chan',
      '2024-05-15',
      '10582',
      'Approved',
      '1132',
      '2024-02-29',
      'Car Accident',
      'John Doe',
      '2024-02-18',
      '***-**-****',
    ],
    [
      '1011',
      'Katherine Hale',
      '2024-05-30',
      '14783',
      'Denied',
      '1113',
      '2024-03-10',
      'Car Accident',
      'John Doe',
      '2024-02-01',
      '***-**-****',
    ],
    [
      '1006',
      'Liam Scott',
      '2024-06-14',
      '8560',
      'Denied',
      '1133',
      '2024-03-20',
      'Vandalism',
      'John Doe',
      '',
      '***-**-****',
    ],
    [
      '1022',
      'Mia Wong',
      '2024-06-29',
      '7512',
      'Denied',
      '1117',
      '2024-03-30',
      'Flood',
      'Jane Smith',
      '',
      '***-**-****',
    ],
    [
      '1017',
      'Nina Turner',
      '2024-07-14',
      '9689',
      'Denied',
      '1124',
      '2024-04-09',
      'Theft',
      'Jane Smith',
      '2024-01-21',
      '***-**-****',
    ],
    [
      '1007',
      'Owen Bennett',
      '2024-07-29',
      '10865',
      'Denied',
      '1120',
      '2024-04-19',
      'Car Accident',
      'Emily Davis',
      '',
      '***-**-****',
    ],
    [
      '1025',
      'Paul Walker',
      '2024-08-13',
      '4395',
      'Denied',
      '1126',
      '2024-04-29',
      'Fire',
      'Jane Smith',
      '2024-01-17',
      '***-**-****',
    ],
    [
      '1014',
      'Quincy Adams',
      '2024-08-28',
      '11104',
      'Denied',
      '1128',
      '2024-05-09',
      'Car Accident',
      'Michael Brown',
      '2024-01-14',
      '***-**-****',
    ],
    [
      '1015',
      'Rachel Zane',
      '2024-09-12',
      '13305',
      'Pending',
      '1114',
      '2024-05-19',
      'Car Accident',
      'Michael Brown',
      '',
      '***-**-****',
    ],
    [
      '1005',
      'Steve Rogers',
      '2024-09-27',
      '6430',
      'Approved',
      '1123',
      '2024-05-29',
      'Theft',
      'Emily Davis',
      '',
      '***-**-****',
    ],
    [
      '1024',
      'Tina Fey',
      '2024-10-12',
      '5912',
      'Approved',
      '1111',
      '2024-06-08',
      'Car Accident',
      'Emily Davis',
      '',
      '***-**-****',
    ],
    [
      '1002',
      'Uma Thurman',
      '2024-10-27',
      '12690',
      'Denied',
      '1127',
      '2024-06-18',
      'Flood',
      'Jane Smith',
      '',
      '***-**-****',
    ],
    [
      '1020',
      'Victor Hugo',
      '2024-11-11',
      '9731',
      'Denied',
      '1135',
      '2024-06-28',
      'Fire',
      'John Doe',
      '',
      '***-**-****',
    ],
    [
      '1016',
      'Wanda Maximoff',
      '2024-11-26',
      '3506',
      'Pending',
      '1112',
      '2024-07-08',
      'Vandalism',
      'Emily Davis',
      '2024-01-07',
      '***-**-****',
    ],
    [
      '1019',
      'Xander Cage',
      '2024-12-11',
      '14072',
      'Approved',
      '1134',
      '2024-07-18',
      'Fire',
      'Jane Smith',
      '',
      '***-**-****',
    ],
    [
      '1004',
      'Yara Greyjoy',
      '2024-12-26',
      '8598',
      'Denied',
      '1130',
      '2024-07-28',
      'Vandalism',
      'Jane Smith',
      '2024-02-16',
      '***-**-****',
    ],
  ],
  Policy_Holders: [
    [
      '1111',
      'Alice Johnson',
      '9788',
      'Auto',
      '2023-12-01',
      '2024-12-01',
      '***-**-****',
    ],
    [
      '1112',
      'Bob Smith',
      '1115',
      'Home',
      '2023-12-11',
      '2024-12-11',
      '***-**-****',
    ],
    [
      '1113',
      'Charlie Brown',
      '1122',
      'Auto',
      '2023-12-21',
      '2024-12-21',
      '***-**-****',
    ],
    [
      '1114',
      'David Wilson',
      '1125',
      'Auto',
      '2023-12-31',
      '2024-12-31',
      '***-**-****',
    ],
    [
      '1115',
      'Eva Green',
      '1119',
      'Home',
      '2024-01-10',
      '2025-01-10',
      '***-**-****',
    ],
    [
      '1116',
      'Frank Harris',
      '1116',
      'Auto',
      '2024-01-20',
      '2025-01-20',
      '***-**-****',
    ],
    [
      '1117',
      'Grace Lee',
      '1121',
      'Auto',
      '2024-01-30',
      '2025-01-30',
      '***-**-****',
    ],
    [
      '1118',
      'Hannah King',
      '1118',
      'Home',
      '2024-02-09',
      '2025-02-09',
      '***-**-****',
    ],
    [
      '1119',
      'Isaac Clarke',
      '1129',
      'Auto',
      '2024-02-19',
      '2025-02-19',
      '***-**-****',
    ],
    [
      '1120',
      'Jackie Chan',
      '1132',
      'Auto',
      '2024-02-29',
      '2025-02-29',
      '***-**-****',
    ],
    [
      '1121',
      'Katherine Hale',
      '1113',
      'Home',
      '2024-03-10',
      '2025-03-10',
      '***-**-****',
    ],
    [
      '1122',
      'Liam Scott',
      '1133',
      'Auto',
      '2024-03-20',
      '2025-03-20',
      '***-**-****',
    ],
    [
      '1123',
      'Mia Wong',
      '1117',
      'Home',
      '2024-03-30',
      '2025-03-30',
      '***-**-****',
    ],
    [
      '1124',
      'Nina Turner',
      '1124',
      'Auto',
      '2024-04-09',
      '2025-04-09',
      '***-**-****',
    ],
    [
      '1125',
      'Owen Bennett',
      '1120',
      'Home',
      '2024-04-19',
      '2025-04-19',
      '***-**-****',
    ],
    [
      '1126',
      'Paul Walker',
      '1126',
      'Auto',
      '2024-04-29',
      '2025-04-29',
      '***-**-****',
    ],
    [
      '1127',
      'Quincy Adams',
      '1128',
      'Auto',
      '2024-05-09',
      '2025-05-09',
      '***-**-****',
    ],
    [
      '1128',
      'Rachel Zane',
      '1114',
      'Home',
      '2024-05-19',
      '2025-05-19',
      '***-**-****',
    ],
    [
      '1129',
      'Steve Rogers',
      '1123',
      'Auto',
      '2024-05-29',
      '2025-05-29',
      '***-**-****',
    ],
    [
      '1130',
      'Tina Fey',
      '1111',
      'Home',
      '2024-06-08',
      '2025-06-08',
      '***-**-****',
    ],
  ],
  Users: [
    [
      'user1',
      'john_doe',
      'john@example.com',
      '2023-01-01T10:30:00.000Z',
      'active',
    ],
    [
      'user2',
      'jane_smith',
      'jane@example.com',
      '2023-02-15T09:20:00.000Z',
      'inactive',
    ],
    [
      'user3',
      'alice_wonder',
      'alice@wonderland.co',
      '2023-03-10T14:45:00.000Z',
      'active',
    ],
  ],
  Orders: [
    [
      'order1',
      'user1',
      '["itemA","itemB"]',
      '59.99',
      '2023-02-25T16:15:00.000Z',
      'user1',
    ],
    [
      'order2',
      'user2',
      '["itemX","itemY","itemZ"]',
      '120.5',
      '2023-03-01T11:00:00.000Z',
      'user2',
    ],
    [
      'order3',
      'user3',
      '["itemD"]',
      '15.0',
      '2023-04-10T09:05:00.000Z',
      'user3',
    ],
  ],
  Products: [
    ['prod1', 'Laptop', 'Electronics', '999.99', 'true', '["tech","premium"]'],
    ['prod2', 'Bananas', 'Groceries', '2.49', 'true', '["food"]'],
    ['prod3', 'T-Shirt', 'Apparel', '14.99', 'false', '["clothing","sale"]'],
  ],
};

export const getMockHeaders = (tableName: string) => {
  if (tableName && headers[tableName]) {
    return headers[tableName];
  }

  return headers.Claims;
};

export const getMockData = (tableName: string) => {
  if (tableName && data[tableName]) {
    return data[tableName];
  }

  return data.Claims;
};
